import { render } from "./ProsesPengajuanKerjasama.vue?vue&type=template&id=8907d038"
import script from "./ProsesPengajuanKerjasama.vue?vue&type=script&lang=js"
export * from "./ProsesPengajuanKerjasama.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__